import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('NetworkCategory')
export class NetworkCategory {
  @JsonProperty('serializedEnum', String, true) serializedEnum: string = undefined;
  @JsonProperty('description', String, true) description: string = undefined;
  @JsonProperty('network', String, true) network: string = undefined;
}
